var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("toast-container"),
      _vm._v(" "),
      !_vm.isQuotePage
        ? _c("navigation-bar", { on: { stepCompleted: _vm.goto } })
        : _vm._e(),
      _vm._v(" "),
      _vm.isNotificationVisible
        ? _c(
            "notification-bar",
            {
              attrs: { type: "info", actionText: "Learn more" },
              on: { onClose: _vm.handleCloseNotification },
            },
            [
              _c("p", [
                _c("b", [_vm._v("Attention: ")]),
                _vm._v("\n        Google is shaking things up. "),
                _c("b", [_vm._v("Starting on Oct 23, 2023")]),
                _vm._v(
                  ", students\n        (under 18) can't use Google SSO for unauthorized school apps. This means\n        your students might have trouble signing in.\n      "
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isGoogleSSOPopupVisible
        ? _c(
            "GenericNotification",
            {
              attrs: {
                name: "google-sso-warning",
                image: "/assets/app/class/google_owl.svg",
                title: "Are your students signing in with Google?",
                subtitle: "👉 Recommended Action:",
                actionText: "Request Log In Cards",
                "notification-bar": {
                  type: "warning",
                  actions: false,
                },
              },
              on: {
                onSkip: _vm.handleSkipNotification,
                onAction: _vm.handleNotificationAction,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "notification",
                    fn: function () {
                      return [
                        _c("span", [
                          _vm._v("\n            Google is shaking things up. "),
                          _c("b", [_vm._v("Starting on Oct 23, 2023")]),
                          _vm._v(
                            ", students (under 18) can't use Google SSO for unauthorized school apps. This means your students might have trouble signing in.\n          "
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                3111917309
              ),
            },
            [
              _c("span", [
                _vm._v(
                  "\n          We can generate passwords for you and your students and email you Log In Cards for them. This allows you to use\n          a standard username and password login method.\n          For more details,\n          "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      target: "_blank",
                      href: "https://readtheory.org/teachers-lounge/important-google-sso-access-changes-for-students/",
                    },
                  },
                  [_vm._v("\n            check out this blog.\n          ")]
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "PageBody",
        [
          _c("subscription-result-modal", {
            attrs: { type: _vm.subscriptionResultType },
            on: {
              close: function ($event) {
                _vm.subscriptionResultType = null
              },
            },
          }),
          _vm._v(" "),
          _c("router-view", { on: { stepCompleted: _vm.goto } }),
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }